module.exports = __webpack_public_path__ + "img/kh6.c9766b0a.png";